// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1646":"510ae2f2cc90e781","4573":"6499b7776931c105","5139":"807aeeb1e91c9342"}[chunkId] + ".js";
};